import pkg from '../../../../package.json';

export const environment = {
  production: true,
  env: 'staging',
  version: pkg.version,
  platform: 'webapp',
  baseUrl: 'https://staging-api-mobile.glowingbud.com',
  paymentMsUrl: 'https://staging-api.payment.microservice.glowingbud.xyz',
  translateApiUrl: 'https://dev-gb-qrcode-generator.glowingbud.xyz/translate',
  s3BucketUrl: 'https://assets.glowingbud.com',
  universalURL: 'https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=',
  previewMode: false,
  appleSocialAuth: {
    clientId: '',
    scope: 'name email',
    redirectURI: '',
    usePopup: true,
    state: 'gbsocialsignup',
  },
  googlePayMerchantId: '',
};
